import styled from 'styled-components';

export const ActionItem = styled.button.attrs({ type: 'button' })`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #007aff;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;
